import React from 'react'

function PlanFeaturesSection({ children }) {
    return (
        <div className="w-full xl:w-1/4 md:w-1/4">
            <div className="relative flex flex-col h-full py-8 px-2">
                {children}
            </div>
        </div>
    )
}

export default PlanFeaturesSection